// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"styles_buttonWrapper__mnvPn","editButton":"styles_editButton__wZba1","editButtonContainer":"styles_editButtonContainer__k4Gfh"};